import type { MenuConfig } from '~typings/menu'

import permission, { RESOURCE_CAJA_CHICA } from '@/auth/permissions/modules/cajaChica'
import * as names from '@routes/caja-chica/nombres/mantenimiento'

const { mantenimiento } = permission

export default [
    {
        title: 'caja_chica.subopciones.crear_caja_chica',
        route: names.ROUTE_CREAR_CAJA_CHICA,
        resource: RESOURCE_CAJA_CHICA,
        action: mantenimiento.crearCajaChica,
    },
    {
        title: 'caja_chica.subopciones.crear_tipo_gasto',
        route: names.ROUTE_CREAR_TIPO_GASTO,
        resource: RESOURCE_CAJA_CHICA,
        action: mantenimiento.crearTipoGasto,
    },
] as MenuConfig[]
